export const HIDE_IDENTIFICATION_INLINE_ALERT_KEY = 'hideIdentificationInlineAlert';
